export function initScrolledLogoSwap() {
  const headerGroup = document.querySelector(
    ".shopify-section-group-header-group",
  );
  const headerTop = document.querySelector(".c-header-top");
  const headerLogo = document.querySelector(
    ".c-header-main .header-logo-link",
  );

  if (!headerGroup || !headerTop) return;

  const isMobile = () => window.innerWidth <= 900;

  let lastScrollY = window.scrollY;
  let ticking = false;

  function update() {
    const scrollY = window.scrollY;
    const topBarH = headerTop.offsetHeight;
    const mobile = isMobile();

    if (!mobile) {
      // Desktop: slide top bar away when scrolled past it, main header stays visible
      headerGroup.style.transform =
        scrollY > topBarH ? `translateY(-${topBarH}px)` : "translateY(0)";
    } else {
      // Mobile:
      // at top → show everything
      // scroll down past 80px → hide everything
      // scroll up intent → peek main header (hide only top bar)
      if (scrollY <= topBarH) {
        headerGroup.style.transform = "translateY(0)";
      } else if (scrollY > lastScrollY && scrollY > 80) {
        headerGroup.style.transform = "translateY(-100%)";
      } else if (scrollY < lastScrollY) {
        headerGroup.style.transform = `translateY(-${topBarH}px)`;
      }
    }

    // Compact the full wordmark down to the mark-only logo on every device.
    headerLogo?.classList.toggle("is-scrolled", scrollY > 50);
    headerGroup.classList.toggle("is-scrolled", scrollY > 50);

    lastScrollY = scrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll);
  update();
}
